import React from 'react';

import { CreateRoutingFilterPreFill } from './routingFilterDialog/RoutingFilterDetailsDialog';

export type RoutingFiltersActionsContextValue = Readonly<{
  onEditFilterClicked: (filterId: string) => void;
  onDeleteFilterClicked: (filterId: string) => void;
  onAddFilterClicked: (preFill?: CreateRoutingFilterPreFill) => void;
  // Resolves true once the deleted-project references were cleared successfully
  // (false on error/no-op), so callers can refresh their own view in place.
  onClearUnspecifiedProjectsClicked: (filterId: string) => Promise<boolean>;
}>;

export const RoutingFiltersActionsContext = React.createContext<RoutingFiltersActionsContextValue | null>(null);

export function useRoutingFiltersActions(): RoutingFiltersActionsContextValue {
  const context = React.useContext(RoutingFiltersActionsContext);
  if (!context) {
    throw new Error('useRoutingFiltersActions must be used within a RoutingFiltersActionsContext.Provider');
  }
  return context;
}
